import { useCallback } from 'react';

import { useCanReviewInViewMode } from '../useCanReviewInViewMode.ts';
import { useShowSuggestionsPanel } from '../useShowSuggestionsPanel.ts';

/**
 * Returns the Review action that opens the Suggestions panel on a published page, or undefined when it isn't available.
 *
 * @param contentId - The published content id. Pass undefined when the caller isn't eligible for Review.
 * @param contentType - The content type, used to check edit permission.
 */
export const usePublishedPageReviewAction = (
	contentId: string | undefined,
	contentType: string | null | undefined,
): (() => void) | undefined => {
	const canReviewInViewMode = useCanReviewInViewMode(contentId, contentType);
	const { showSuggestionsPanel } = useShowSuggestionsPanel();
	const showPublishedSuggestionsPanel = useCallback(
		() => showSuggestionsPanel({ publishedContentId: contentId }),
		[contentId, showSuggestionsPanel],
	);

	return canReviewInViewMode ? showPublishedSuggestionsPanel : undefined;
};
